import { useSelector } from 'react-redux';
import { getProfileSession } from '../../../redux/actions/dbactions/profileActions';

export const WalletDashboard = ({ data = false }) => {
  const { profileData } = getProfileSession();
  const { recentTransactions } = useSelector((state) => state.wallet);

  const profile = data ? data : profileData;
  return (
    <div className="p-3 md:p-4">
      <h2 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">
        My eWallet Dashboard
      </h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="p-3 md:p-4 bg-blue-500 text-white rounded-lg">
          <h3 className="text-lg font-semibold">eBalance</h3>
          <p className="text-xl">${profile.wallet_balance || '0.00'}</p>
        </div>
        <div className="p-3 md:p-4 bg-green-500 text-white rounded-lg">
          <h3 className="text-lg font-semibold">Recent Transactions</h3>
          <p>
            {recentTransactions.length > 0
              ? `${recentTransactions.length} new transactions`
              : 'No new transactions'}
          </p>
        </div>
      </div>
    </div>
  );
};
